import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { WaterfallFilterType } from '@bingads-webui-campaign/filter-storage';
import { withGlobalFilter } from '@bingads-webui-campaign-react/global-filter-context';
import {
  getFilteredCampaignTypeFromRawFilter,
  convertFilteredCampaignTypeToFilter,
  CampaignType,
  CampaignTypeToStringMap
} from '@bingads-webui-campaign-react/shell-ui-common';
import { withCurrentExpandedScopeNoFallback } from '@bingads-webui-campaign-react/use-current-scope-entity';


const CampaignTypeUpdater = (props) => {
  const { currentCampaign, updateWaterfallFilter, [WaterfallFilterType.CampaignType]: campaignTypeFilter } = props;
  const selectedCampaignTypeFilter = useMemo(() => getFilteredCampaignTypeFromRawFilter(campaignTypeFilter), [
    campaignTypeFilter,
  ]);

  useEffect(() => {
    if (selectedCampaignTypeFilter !== CampaignType.All
      && currentCampaign && currentCampaign.CampaignType
      && CampaignTypeToStringMap[selectedCampaignTypeFilter] !== currentCampaign.CampaignType) {
      updateWaterfallFilter({
        filterType: WaterfallFilterType.CampaignType,
        filter: convertFilteredCampaignTypeToFilter(CampaignType.All),
      });
    }
  }, [currentCampaign, selectedCampaignTypeFilter, updateWaterfallFilter]);

  return null;
};

CampaignTypeUpdater.defaultProps = {
  currentCampaign: null,
};

CampaignTypeUpdater.propTypes = {
  currentCampaign: PropTypes.shape({
    CampaignType: PropTypes.string.isRequired,
  }),
  updateWaterfallFilter: PropTypes.func.isRequired,
};

const Component = withGlobalFilter(withCurrentExpandedScopeNoFallback(CampaignTypeUpdater));
export { Component as CampaignTypeUpdater };
